(function (angular) {
    angular.module('shared').directive('moDateOutput', function ($window) {
        return {
            require: '^ngModel',
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {
                var moment = $window.moment;
                var outputFormat = attrs['moDateOutput'];
                var inputFormat = attrs['moInput'];
                attrs.$observe('moDateInput', function (newValue) {
                    if (outputFormat === newValue || !ctrl.$modelValue) return;
                    outputFormat = newValue;
                    ctrl.$modelValue = new Date(ctrl.$setViewValue);
                });

                ctrl.$formatters.unshift(function (modelValue) {
                    if (!outputFormat || !modelValue) return "";
                    return moment(modelValue, inputFormat).format(outputFormat);
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var date = moment(viewValue, outputFormat);
                    return (date && date.isValid() && date.year() > 1950) ? date.toDate() : "";
                });
            }
        };
    });

}(angular));